var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFivebet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187.833,
    height: 59.227,
    viewBox: "0 0 187.833 59.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-216.19H187.833v59.227H0Z",
    transform: "translate(0 216.19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2055 363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2055 -363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.455 5.772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-450.012-46.737h-6.341l-2.515,14.2-.889,5.316-90.893-.01.851-8.737-3.5,8.737h-15.237l-1.131-8.758-1.534,8.758h-24.69l1.5-8.56h-5.036l-1.535,8.56H-617.2l6.164-34.944h163.725Zm2.7-17.635H-612.88l-.319,1.811-6.164,34.944-.454,2.572h57.847l102.213.011h1.856l.306-1.83.887-5.307,2.192-12.375h6.346l.317-1.815,2.7-15.444.448-2.569Z",
    transform: "translate(619.817 64.372)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.986 20.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.566-12.148l.335-.65.357-.756.529-1.553L.037-16.732-.78-12.1Z",
    transform: "translate(0.78 16.732)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.855 18.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.794-1.276l-.184-.179-1.406-.3L-6.6-.515l.634.569.113.635L-5.1.908-3.175-.538l-.546-.173L-3.658-1Z",
    transform: "translate(6.603 1.757)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.154 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.282,0-4.52,7.02l2.326.5L-3.679,5.646l.649-1.082.139,1.418.8.283.142.5.627.441.113-.781L-.792,6.3.143,4.664-.041,6.291l-.366.282L-.5,7l-.56.407-.076.484.622.079.381-.224.425.092.488-.59.47-.121.287-1.076.37-.171.1-.866L1.588,4.92l.158-.6L.213,1.762l.811.619,1.093.985.3,1.064,1.7-.662.451.1,1.709,1.09.04.2.366.107.254-.278,2.223-.133-2.8,1.12L4.889,4.936,4.374,4.88,2.246,6.117l0,.5-.273.108-.666,1.8-.076.484.6,1.325-.074.345.494.8-.027.383L4.6,13.9l2.888-1.156,1.928-1.474.647-.216H3.628l.537-3.071H14.491L15.911,0Z",
    transform: "translate(4.52)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.149 22.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.163-.041l-1.988.849.119.22-1.528,1.032,1.689.669L-19.705,3.9l.949.621-1.033.027-.322-.569-.321.07-.244-.413-1.465-.676-.485.062-.185-.429-.844-.21-1.841.937.113.636L-25.6,5.627l.222.131-.291,1.353-.676.688-.042.168h7.9l1.42-8.023H-19.1Z",
    transform: "translate(26.393 0.056)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.517 20.384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.52-25.955l.239.052.584-1.68-.261-.334-1.15.7-2.553.894-1.182.718.492-.866.933-.466,3.11-1.413.192-1.792-1.041-.585-.126-.444-.594,1.983-.069-1.487-.45-1.264-3.541,2.515-1.422-.362,1.146-.031.8-.244,2.538-1.981.177-.823L-35.388-35.2l.092-.425-.557-.12-2.753,1.823-.685,1.63-.427.435-.229,1.062-1.114.353-2.351,13.33h8.829l1.535-8.56h1.456Z",
    transform: "translate(43.413 35.749)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.822 22.868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-41.806-2.131l-2.009-.8L-46.181-.9l.027.383-.494.8.074.345-.6,1.325.076.483.666,1.8.273.108,0,.5,2.127,1.236.516-.056,1.471-1.039,2.8,1.12-2.223-.132-.254-.278-.366.106-.04.2L-43.848,7.1l-.451.1L-46,6.534-46.3,7.6l-1.093.986L-48.2,9.2l1.533-2.552-.158-.6.425-.092-.1-.866-.37-.17-.287-1.077-.47-.121-.488-.589-.424.091L-48.925,3l-.622.078.076.484.56.407.091.424.366.282.184,1.627L-49.2,4.67l-.418-.133-.113-.781-.627.441-.142.5-.8.283L-51.442,6.4l-.65-1.082,1.485-1.875-1.122.241-.21,1.2h-4.184l-1.459,8.329h17.274l1.459-8.329h-4.184Z",
    transform: "translate(57.581 2.935)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.2 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.257-26.831l.239-.061,3.541,2.515.45-1.264.068-1.487.594,1.983.126-.444,1.041-.585-.192-1.792L-7.5-29.378l-.933-.466-.492-.866,1.182.717,2.553.895,1.15.7.262-.334-.584-1.68-.239.052-.3-1.156.437-3.26.912,2.942L-4-31.188l.181.711.676.687.291,1.354-.222.131.222,1.674-.113.636,1.346.686.58-3.316H3.146L4.6-36.955H-12.669l-1.459,8.33h4.184Z",
    transform: "translate(14.128 36.955)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.227 21.835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.989-5.9l-2.538-1.981-.8-.244h-.02l-.786,4.494,2.167,1.435.557-.12-.091-.425,1.691-2.336Z",
    transform: "translate(15.136 8.123)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.76 26.959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.945,0-1.3,2.039l.037-.008.184-.179L.055,1.581l-.063-.292.546-.173Z",
    transform: "translate(1.301)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.886 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-59.382-31.5l-.529-.384-.263.2-.394-.275-1.614-.007-.416.258-.347-.313-.855.16-1.284,1.617.367.531.494,1.615.256.027.3,1.353-.329.906.131.722.673.408.394,3.055-1.752-2.784-.2-1.178.239-.053-.167-1.77-.377-.2-.756,1.112-.731.7a1.76,1.76,0,0,1,.035.913c-.192,1.036-.96,1.535-3.071,1.535h-2.073l.576-3.224h2.073a4.4,4.4,0,0,1,2.047.321l1.4-1.611-.571-1.71-1.189-.1-.3-.351.285,2.05-.681-1.324-.934-.962L-71.126-26.5l-1.444.262,1.029-.5.629-.555,1.484-2.856-.181-.822L-72.117-32.4l-.094-.424-.557.122-1.747,2.8.055,1.767-.207.574.233,1.061-2.11,1.91.081-1.019,1.166-.9.034-.73.011-.836-.164-1.632-1.243-1.228-.091-.286.836.261.367.531.781-.116,1.147-2.115-.568.069-.064-.291-1.146.224-.241-.086-1.724.379.007-.474,2.519-.554-2.13-1.089.141-1.254.716,1.232.845-.075.338.4.754.14-.222-.758.325-.294.172-1.873.509,1.556-.216.409.093.424-.34.6.132.472.6-.187.254-.362.424-.093.2-.739.378-.305-.186-1.1.266-.309-.266-.831-.424.093-.108-.616-2.455-1.684.995.226,1.4.442.714.844,1.27-1.308.45-.1,2.008.281.121.168.377-.055.115-.359,1.967-1.044L-67.7-38.344l-1.769-.334-.492.164-1.421,2.009.211.454-.2.211.143,1.914.131.472,1.1.954.076.345.782.523.134.359,3,.87,2.146-2.252L-62.72-34.8l2.145-2,.843-.213.275-.394.046.462-1.307,1.01-1.456,1.6.2.15-.961,1.574,1.814-.093,1.545.578,1.122.17Zm-5.786-3.326c-.153,1.036-.767,1.535-2.3,1.535h-2.419l.538-3.071h2.457c1.459,0,1.919.461,1.727,1.536m8.6-.154c.729-4.03-.767-6.372-3.915-7.562a16.484,16.484,0,0,0-5.643-.845H-76.914l-4.875,27.638H-69.16c7.1,0,10.671-2.764,11.477-7.6.614-3.378-.422-5.412-2.533-6.6a6.411,6.411,0,0,0,3.647-5.029",
    transform: "translate(81.789 43.385)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.391 20.912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50.648-27.1l-.077-.105h-5.411l.036.164.409.325-.047.847,1.254.676-1.249.181-1.155-2.095-.474,2.536-.474.022.324-1.735-.094-.238.111-.683h-2.039l-.2.119-.091.784.542.35.287.827-.289-.081-1.267-1.2-1.636-.113-.836.038-.729.057-.858,1.193-1.016.114,1.842-2.17,1.067.2.567-.225h1.768l.986-.659.274-1.417H-57.6l.06-.319-.427-.08-1.5-2.463-.827-.155L-63.1-30.837l-.535.646-.471,1.044.216-1.451,3.688-2.294-.991-.9-1.345-.638,2.058.219-.361-.288-.137-1.186L-62.7-36.2l-2.505,2.322L-66-33.2l-.989.119,1.118-.813,1.812-2.009,1.087-.792-.207-.37-1.775-.111-.045.24-1.184-.166-.385-.225L-69.76-19.222h20.153l1.42-7.984h-2.489Z",
    transform: "translate(69.76 37.328)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.909 27.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.5,0l-.3.275-1.1-.151L-8.2.511l-.732.222-.024.129h3.911L-5.126.755-5.744.667l.08-.427Z",
    transform: "translate(8.957)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.793 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.9,0-5.377,8.352l.4.039.429.66.725.108.9-.357,1.361.254.035.255L.1,9.754l.542.35L2.22,8.769l.133-.859-.324-.337.245-.424L2.217,5.537,1.93,5.152l.188-.269-.4-.517.425-.942.206,1.116.626,1.526L2.939,7.881l1.542-1.01.157.2L6.19,5.561l.968-1.338.464.031-.385.287L7.05,5.39,5.119,7.6l0,0h9.83L16.287,0Z",
    transform: "translate(5.377)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.002 19.958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.837,0l-.4.229L-9.417,2.445l.964,2.97.363.123.548.765.347.065.988,1.068.475.117,1.918.082.205-.21.461.2,1.962-1.484.148-.5-.39-1.758L.687,1.737l-.981,2-.355.127-.043.378.172.115.345,2-.085.454-1.267,1.31.866.687.029.083H2.391L3.734,1.249H-7.052Z",
    transform: "translate(9.417)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.413 17.722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.153-3.687.268-3.8l.39.208.619-.1-.1-.48L.606-4.554.5-4.975l-.146-.1L-.211-3.752Z",
    transform: "translate(0.211 5.079)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.614 23.128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.2-.228-.211-.315l-.066.157Z",
    transform: "translate(0.277 0.315)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.234 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.693-16.31l.422.116.142.776.61-.465L.6-16.39l.788-.314.084-1.423.691,1.056L.756-15.139l2.5-.64.22.42-1.71.438-.177.186L.464-14.42l.074.289L0-13.936l1.977,1.371.749-.248.089-.639.629-.61.048.3-.557,1.656.588,1.531.386.742.359.637.522.1,6.366-13.363H1.482L-.955-16.728Z",
    transform: "translate(0.955 22.464)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.471 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.651-30.53l1.984,1.4,2.93,1.043,1.09-1.014-.642-7.7-.573-.3-.513.075-1.429,1.095-2.837-1.011,2.226.046.265.268.361-.121.032-.2,1.666-1.155.447-.115.244.084-.325-3.9h-8.944L-13.281-31.3Z",
    transform: "translate(14.671 42.051)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.534 20.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.809-12.692l-.27-1.052-.443-.419-.747-1.6-2.822-1.716-.552.141.108.421-1.6,2.4.209.815,2.612,1.882.811.213,1.146-.013-1.407.416L-49.4-13.583l-.4,1.28-.011,1.488-.67-1.959-.11.449-.26.16-.04.1-.006-.067-.71.437.26,1.783,3.162,1.292.951.429.525.846-1.209-.671L-50.5-8.815l-1.176-.652-.248.344.648,1.656.237-.061.349,1.144L-51-3.109l-1.025-2.9.418-.667-.208-.7-.7-.661-.344-1.342.217-.14-.286-1.665.088-.639-1.875-.865-.835.242-.169.436-.488-.043-1.438.732-.228.423-.323-.057-.3.581-.461.005,1.507,11.665h9.136l6.527-13.7Z",
    transform: "translate(58.963 17.481)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.938 22.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.67-.129-.923-.177l.548,4.246.4-.283L1.144,2.574,2.805,1.84,1.239.868,1.35.643Z",
    transform: "translate(0.923 0.177)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.454 20.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-51.233-27.412l-.077-.105h-5.411l.035.164.409.325-.047.847,1.255.676-1.249.181-1.156-2.095-.474,2.536-.474.022L-58.1-26.6l-.094-.238.111-.683h-2.039l-.2.119-.091.784.543.35.287.827-.289-.081-1.267-1.2-1.636-.113-.835.038-.729.057-.858,1.193-1.016.114,1.842-2.17,1.068.2.567-.225h1.768l.732-.489.306-1.586h1.752l.06-.319-.427-.08-1.5-2.463-.827-.155-2.808,1.575-.535.646-.471,1.044.216-1.451,3.688-2.294-.991-.9-1.345-.638,2.058.219-.36-.288L-61.561-36l-1.727-.516-2.505,2.322-.79.681-.989.119,1.118-.813,1.812-2.009,1.087-.792-.207-.37-1.775-.111-.045.24-1.185-.166-.585-.343-3.214,18.223h20.152l1.421-7.984H-51.26Z",
    transform: "translate(70.565 37.756)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.193 27.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.5,0l-.3.275-1.1-.151L-8.2.511l-.732.222-.024.129h3.911L-5.124.755-5.743.667l.08-.427Z",
    transform: "translate(8.956)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.86 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.894,0l-1.47,8.332.621.06.429.66.725.108.9-.357,1.361.254.035.255,1.63.443.543.35L2.451,8.769l.133-.859L2.26,7.573l.245-.424L2.447,5.537,2.16,5.152l.188-.269-.4-.517.425-.942.206,1.116.626,1.526L3.17,7.881l.42-.275V7.6H3.6l1.114-.729.157.2L6.42,5.561l.968-1.338.464.031-.385.287-.186.849L5.349,7.6l0,0h9.609L16.3,0Z",
    transform: "translate(5.364)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.287 20.099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.189,0l-.153.088L-8.524,2.3l.964,2.97L-7.2,5.4l.548.766.347.065L-5.314,7.3l.476.117,1.918.082.2-.21.46.2L-.292,6l.148-.5-.39-1.758L1.58,1.6l-.982,2-.355.127L.2,4.1l.172.115.345,2-.084.454L-.634,7.977l.866.687.029.083h2.8L4.407,1.108H-6.38Z",
    transform: "translate(8.524)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.456 23.255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.437-22.992l.513.075,1.684-.637,1.9,1.4,1.271-7.176-.386-.493L-2.96-31.668l-2.8,1.379-.069.378-.679.651-.015.353-.916,1.131-.047.487.193,1.91.238.173-.129.484Z",
    transform: "translate(7.488 31.668)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.775 21.223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-14.5l.523.022.018-.434,2.222-1.838.035-.841L.969-19.975Z",
    transform: "translate(0 19.975)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.795 11.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.75,0-5.165,8.108l.047.03h6.2L.835,9.555,3.1,12.244l.752-1.11.439-1.422L4.37,11.78l.234-.4,1.154-.306.264-1.783L3.365,7.146l-.788-.685L2.318,5.5l.965.991L5.531,8l.939.963L6.806,8.7,6.662,6.928l-.244-.01-.005-1.2,1.24-3.047L7.8,5.752,7.2,6.271,7.2,7l.482.835L7.627,9.224l-.247.071-.205,1.677-.268.587,1.547,1.368.69.007.849-4.8h6.334L17.746,0Z",
    transform: "translate(5.165)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.592 27.756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22.316-12.489l-.176-.333-.381.011-.089.187L-24.89-12l-.461-.019-1.478-1.066-.556.956-1.305.68-.94.4,2.124-2.087v-.625l.434.018.117-.865-.315-.258-.009-1.115-.425-.235-.325-.693-.434-.018-.276-.274-.246,1.388.245.316-.23,1.621-.217-.8-1.548,8.734h8.906l1.071-6.046Z",
    transform: "translate(30.736 17.201)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.789 48.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.925,0l-.349,2.034H27.242V0Z",
    transform: "translate(1.275)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.271 51.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.925,0l-.349,2.034H27.761V0Z",
    transform: "translate(1.275)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.55 51.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-74.649-5.391l.349-2.034h-28.517v2.034Z",
    transform: "translate(102.817 7.425)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.55 48.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.023-5.391l.349-2.034h-29.035v2.034Z",
    transform: "translate(104.709 7.425)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.702 48.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-32.778-11.109c-1.215.619-3.071.854-6.009.854a22.809,22.809,0,0,1-4.175-.3c-2.011-.418-2.562-1.191-1.944-2.288l.022-.04a3.428,3.428,0,0,1,1.524-1.406c1.392-.713,3.468-1.009,6.341-1.009,4.551,0,6.8.754,6.009,2.14l-.088.155h-5.368l.133-.229c.287-.5-.133-.666-1.083-.666a1.9,1.9,0,0,0-2.054,1.11,2.176,2.176,0,0,0-.265.659c-.022.323.287.437,1.127.437,1.1,0,1.48-.182,1.768-.706l.066-.114,5.435-.007-.088.148a3.155,3.155,0,0,1-1.348,1.265",
    transform: "translate(45.147 15.301)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.533 48.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.879-9.378a1.859,1.859,0,0,0,1.281-.976c.53-.881.221-1.15-.994-1.15a2.1,2.1,0,0,0-2.121,1.09c-.464.848-.265,1.117.928,1.117a4.484,4.484,0,0,0,.906-.081m-5.258,1.2c-2.032-.424-2.629-1.211-2.01-2.307l.022-.034a3.465,3.465,0,0,1,1.591-1.413,15.3,15.3,0,0,1,6.34-.982,21.01,21.01,0,0,1,3.711.275c2.1.37,3.093,1.117,2.408,2.308l-.022.034a3.82,3.82,0,0,1-1.392,1.359c-1.215.72-3.181,1.07-6.407,1.07a22.266,22.266,0,0,1-4.242-.31",
    transform: "translate(27.38 12.917)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.751 48.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.7-13.479H-17.5l2.806-5.086h4.838L-7.049-16.1-5.7-18.565H-.93l-2.805,5.086H-8.441l-2.916-2.437Z",
    transform: "translate(17.499 18.565)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.762 48.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.857-13.424h-5.125L-20.994-17h-3.6l.817-1.491h12.371L-12.223-17h-3.645Z",
    transform: "translate(24.595 18.489)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.449 48.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-13.424l2.806-5.065h11.62L13.653-17.1H7.114l-.221.408H13.1l-.773,1.4H6.12l-.243.4h6.539L11.6-13.424Z",
    transform: "translate(0 18.489)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.522 48.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.219-12.857c-1.9-.29-2.541-.828-2.3-1.561H-3.06l-.022.046c-.11.216.088.4,1.061.4.685,0,1.06-.081,1.149-.236.155-.182-.685-.316-2.431-.457a17.656,17.656,0,0,1-2.1-.289c-1.3-.262-2.054-.679-1.635-1.386.508-.828,2.629-1.373,6.539-1.373,4.154,0,6.186.538,5.855,1.635H.211c.11-.269-.221-.4-1.017-.4-.618,0-.972.088-1.038.2a.1.1,0,0,0,.066.155,12.376,12.376,0,0,0,2.231.289A23.23,23.23,0,0,1,2.8-15.5c1.369.269,2.1.686,1.678,1.392-.53.929-2.916,1.467-6.826,1.467a27.235,27.235,0,0,1-3.866-.215",
    transform: "translate(8.565 17.708)",
    fill: "#ffcd03"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.308 48.379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.858-13.452h-5.125L-21-17.034h-3.6l.817-1.494h12.372l-.817,1.494H-15.87Z",
    transform: "translate(24.596 18.528)",
    fill: "#ffcd03"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFivebet);
export default __webpack_public_path__ + "static/media/logoFivebet.a6a3a9e8f66b44dd7f2242457dfe4196.svg";
export { ForwardRef as ReactComponent };